import React from 'react';
import type { Control } from 'react-hook-form';

import Input from '@components/uikit/Input/Input';
import Select from '@components/uikit/Select/Select';

import useTranslation from '@hooks/useTranslation';

import type { ILanguage } from '@model/language';
import type { ITimezone } from '@model/timezone';

import { PROFILE_FIELDS } from '@pages/Profile/constants/schemaProfile';

import PersonalInfoSkeleton from './PersonalInfoSkeleton';
import style from './style.module.scss';

interface IProps {
  isLoading: boolean;
  control: Control<any>;
  languageList?: Array<ILanguage>;
  timezoneList?: Array<ITimezone>;
}

const PersonalInfo: React.FC<IProps> = ({ isLoading, control, languageList = [], timezoneList = [] }) => {
  const { t } = useTranslation();

  return (
    <div className={style.personalInfo}>
      <div className={style.personalInfoTitle}>{t('Personal info')}</div>
      {isLoading ? (
        <PersonalInfoSkeleton />
      ) : (
        <div className={style.personalInfoFields}>
          <Input name={PROFILE_FIELDS.NAME_FIRST} control={control} label={t('First Name')} />
          <Input name={PROFILE_FIELDS.NAME_LAST} control={control} label={t('Last Name')} />
          <Input name={PROFILE_FIELDS.USERNAME} control={control} label={t('Username')} />
          <Input name={PROFILE_FIELDS.EMAIL} control={control} label={t('Email')} />
          <Input name={PROFILE_FIELDS.COMPANY} control={control} label={t('Company')} />
          <Input name={PROFILE_FIELDS.JOB_TITLE} control={control} label={t('Job Title')} />
          <Input name={PROFILE_FIELDS.PHONE} control={control} label={t('Contact phone')} />
          <Select
            name={PROFILE_FIELDS.TIMEZONE}
            control={control}
            label={t('Timezone')}
            options={timezoneList}
            itemKeys={{ valueFieldKey: 'id', labelFieldKey: 'title' }}
          />
          <Select
            name={PROFILE_FIELDS.LANGUAGE}
            control={control}
            label={t('Language')}
            options={languageList}
            itemKeys={{ valueFieldKey: 'iso_code', labelFieldKey: 'name' }}
          />
        </div>
      )}
    </div>
  );
};

export default PersonalInfo;
